var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "#1A496D",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3337 29.3335H21.3337M26.667 40.0002H21.3337M42.667 18.6668H21.3337M53.3337 18.1335V45.8668C53.3337 50.3473 53.3337 52.5875 52.4617 54.2988C51.6947 55.804 50.4709 57.0279 48.9656 57.7949C47.2543 58.6668 45.0141 58.6668 40.5337 58.6668H23.467C18.9866 58.6668 16.7464 58.6668 15.0351 57.7949C13.5298 57.0279 12.3059 55.804 11.5389 54.2988C10.667 52.5875 10.667 50.3473 10.667 45.8668V18.1335C10.667 13.6531 10.667 11.4129 11.5389 9.70157C12.3059 8.19628 13.5298 6.97243 15.0351 6.20544C16.7464 5.3335 18.9866 5.3335 23.467 5.3335H40.5337C45.0141 5.3335 47.2543 5.3335 48.9656 6.20544C50.4709 6.97243 51.6947 8.19628 52.4617 9.70157C53.3337 11.4129 53.3337 13.6531 53.3337 18.1335Z",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDraft);
export default __webpack_public_path__ + "static/media/status-draft.b7f5319d09906d7bf8e3e05329414900.svg";
export { ForwardRef as ReactComponent };